import { Alert, Typography } from "@mui/material"
import { ErrorButton } from "lib/@components/colored-buttons/error-button"
import { useDialog } from "lib/@hooks/useDialog"
import { RejectionDialog } from "./rejection-dialog"

export function RejectionAlert({ latestRejectedReviewCycle }) {
    const showRejectionReason = useDialog(<RejectionDialog />, {
        maxWidth: "sm",
        fullScreen: false,
    })
    return (
        <Alert
            data-cy="rejection-alert"
            severity="error"
            sx={{ my: 2 }}
            action={<ErrorButton text="Review" sx={{ alignSelf: "center", mr: 1, mb: 0.5 }} onClick={handleClick} />}
        >
            <Typography variant="body1">Draft has been rejected.</Typography>
        </Alert>
    )

    async function handleClick() {
        await showRejectionReason({
            content: latestRejectedReviewCycle?.rejection?.payload?.content,
            approvedCount: latestRejectedReviewCycle?.decisionCounts?.approved,
            rejectedCount: latestRejectedReviewCycle?.decisionCounts?.rejected,
        })
    }
}
